export default __webpack_public_path__ + "static/media/goopter-ecommerce-multi-language.c640e4ab.png";